import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIssueStatus } from '@/api/model/interfaces';

export default class DrawingPackageIssueStatusOdata extends OdataManager<DrawingPackageIssueStatus> {}
